function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9905 5.1H16.7422V3.65C16.7422 2.74 16.0026 2 15.0831 2H7.8969C6.98737 2 6.23777 2.74 6.23777 3.65V5.1H2.99947C2.44976 5.1 2 5.55 2 6.1C2 6.65 2.44976 7.1 2.99947 7.1H3.96896V20.01C3.96896 21.11 4.8585 22 5.96791 22H17.0321C18.1315 22 19.031 21.11 19.031 20.01V7.09H20.0005C20.5502 7.09 21 6.64 21 6.09C21 5.54 20.5502 5.09 20.0005 5.09L19.9905 5.1ZM8.23672 3.98H14.7533V5.09H8.23672V3.98ZM17.0321 20H5.95792V7.09H17.0221V20H17.0321ZM10.5255 17.98H8.52657V9.02H10.5255V17.98ZM14.4634 17.98H12.4645V9.02H14.4634V17.98Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=Trash.js.map